import ListContainer from "../../Componant/Ui Kit/Lists";

const Lists = () => {
  return (
    <div className="page-body">
      <ListContainer />
    </div>
  );
};

export default Lists;
